<template>
  <BravadoAccordion v-once title="Community Rules" :items="rules" />
</template>

<script>
import BravadoAccordion from '@/components/common/BravadoAccordion/BravadoAccordion';

export default {
  name: 'WarRoomRules',
  components: {
    BravadoAccordion,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rules: [
        {
          label: 'No hate speech',
          description: 'This should be obvious. Violations will result in an immediate ban.',
          expanded: this.expanded,
        },
        {
          label: 'No selling',
          description: 'While this community is about selling, it is not for selling. Use your best judgement.',
          expanded: this.expanded,
        },
        {
          label: 'No recruiting',
          description:
            'This is a platform for salespeople to learn from one another. Keep the recruiting spam on LinkedIn.',
          expanded: this.expanded,
        },
        {
          label: 'No self-promotion',
          description: 'Want to be a LinkedIn Influencer? Go to LinkedIn.',
          expanded: this.expanded,
        },
        {
          label: 'Do not use your company name',
          description: 'This is not a place to publicly shame or promote your company.',
          expanded: this.expanded,
        },
      ],
    };
  },
};
</script>
